import React from "react";
import "../css/QualityObjectives.css";

const QualityObjectives = () => {
  const objectiveImg = "/images/c.jpg";

  return (
    <section className="objectives-section">
      <div className="objectives-container">
        {}
        <div className="objectives-image-box">
          <div className="objectives-dashed-frame"></div>
          <img
            src={objectiveImg}
            alt="Quality Objectives"
            className="objectives-main-img"
          />
        </div>

        {}
        <div className="objectives-text-box">
          <h2 className="objectives-title">Quality Objectives</h2>
          <p className="objectives-description">
            As one of the leading private schools, the values we instill in our
            students are the same values that propel each member of our faculty.
            We live in alignment with our vision, mission, core values, quality
            policy, and quality objectives to get closer to our vision of
            becoming an international standard for learning.
          </p>
        </div>
      </div>
    </section>
  );
};

export default QualityObjectives;
